import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  Col,
  Row,
  Card,
  CardBody,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { useParams } from "react-router-dom";
import Config from "config";
import DeleteButton from "components/Common/DeleteButtonShow";
import TableHm from "components/Common/hmPaginated";
import IdentificationCard from "components/Common/IdentificationCard";

const TypesPublipostageDetail = () => {
  const backUrl = Config.backOffice.url;
  const api = Config.backOffice.apiName;
  let { id } = useParams();
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem("auth_token_" + api);
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const savedTab = localStorage.getItem("typesPublipostageDetail_tab_" + id);
  const [activeTab, setActiveTab] = useState(savedTab || "details");

  const [documentFusionLoading, setDocumentFusionLoading] = useState(true);
  const [documentFusionData, setDocumentFusionData] = useState({
    data: [],
    header: [],
    title: "",
  });
  const [publipostagesLoading, setPublipostagesLoading] = useState(true);
  const [publipostagesData, setPublipostagesData] = useState({
    data: [],
    header: [],
    title: "",
  });

  document.title = "Type doc fusion | Détails";

  const getDocumentFusionHm = async () => {
    setDocumentFusionLoading(true);
    try {
      const response = await fetch(
        `https://www.fluxod.com/${api}/types_publipostages/${id}/hm_documents_fusion`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      const result = await response.json();
      setDocumentFusionData(result);
    } catch (error) {
      console.log(error);
    } finally {
      setDocumentFusionLoading(false);
    }
  };

  const getPublipostagesHm = async () => {
    setPublipostagesLoading(true);
    try {
      const response = await fetch(
        `https://www.fluxod.com/${api}/types_publipostages/${id}/hm_publipostages`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      const result = await response.json();
      setPublipostagesData(result);
    } catch (error) {
      console.log(error);
    } finally {
      setPublipostagesLoading(false);
    }
  };

  const getData = async () => {
    try {
      const response = await fetch(
        `https://www.fluxod.com/${api}/types_publipostages/${id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.status === 403) navigate(`${backUrl}/forbidden`);
      if (response.status === 500) navigate(`${backUrl}/error`);
      if (response.status === 203) navigate(`${backUrl}/error404`);
      if (response.status === 401) {
        localStorage.removeItem("auth_token_" + api);
        localStorage.removeItem("authUser_" + api);
        localStorage.removeItem("sideBar_" + api);
        navigate(`${backUrl}/login`);
        window.location.reload(false);
      }
      const result = await response.json();
      setData(result);

      // Chargement des HMs selon hm_accessibles
      if (result?.hm_accessibles) {
        result.hm_accessibles.forEach(async (key) => {
          if (key === "hm_documents_fusion") await getDocumentFusionHm();
          if (key === "hm_publipostages") await getPublipostagesHm();
        });
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    const editSuccess = localStorage.getItem("editSuccess");
    if (editSuccess === "true") {
      toast.success("Mise à jour réussie");
      localStorage.removeItem("editSuccess");
    }
    localStorage.removeItem("typesPublipostageDetail_tab_" + id);
  }, []);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const CustomNavTabs = () => {
    const navStyle = {
      cursor: "pointer",
      borderRadius: "0px",
      whiteSpace: "nowrap",
    };
    return (
      <Nav pills className="navtab-bg nav-justified custom-nav-tabs">
        <NavItem>
          <NavLink
            style={navStyle}
            className={`nav-link ${activeTab === "details" ? "active" : ""}`}
            onClick={() => handleTabClick("details")}
          >
            {!loading ? (
              data?.sil ||
              data?.detail_types_publipostage?.["Identification"]?.["Label"] ||
              `#${id}`
            ) : (
              <span className="placeholder col-3" style={{ height: "1em" }}></span>
            )}
          </NavLink>
        </NavItem>
        {data?.hm_accessibles?.map((key, index) =>
          key === "hm_documents_fusion" ? (
            <NavItem key={index}>
              <NavLink
                style={navStyle}
                className={`nav-link ${
                  activeTab === "documents_fusion" ? "active" : ""
                }`}
                onClick={() => handleTabClick("documents_fusion")}
              >
                {!loading ? (
                  <span className="d-flex align-items-center justify-content-center gap-1">
                    {documentFusionData?.title || "Documents"}
                    {documentFusionLoading && (
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      />
                    )}
                  </span>
                ) : (
                  <h5 className="card-title placeholder-glow">
                    <span
                      style={{ height: "1em" }}
                      className="placeholder col-6"
                    ></span>
                  </h5>
                )}
              </NavLink>
            </NavItem>
          ) : key === "hm_publipostages" ? (
            <NavItem key={index}>
              <NavLink
                style={navStyle}
                className={`nav-link ${
                  activeTab === "publipostages" ? "active" : ""
                }`}
                onClick={() => handleTabClick("publipostages")}
              >
                {!loading ? (
                  <span className="d-flex align-items-center justify-content-center gap-1">
                    {publipostagesData?.title || "Modèles de fusion"}
                    {publipostagesLoading && (
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      />
                    )}
                  </span>
                ) : (
                  <h5 className="card-title placeholder-glow">
                    <span
                      style={{ height: "1em" }}
                      className="placeholder col-6"
                    ></span>
                  </h5>
                )}
              </NavLink>
            </NavItem>
          ) : null
        )}
      </Nav>
    );
  };

  return (
    <React.Fragment>
      <div className="page-content" style={{ fontFamily: "sans-serif" }}>
        <div className="container-fluid">
          <Row>
            <Col lg="12">
              <Card>
                <CardBody className="border-bottom">
                  <div className="d-flex align-items-center">
                    <h5
                      className="mb-0 card-title flex-grow-1"
                      style={{ fontWeight: "bold", display: "flex" }}
                    >
                      <Link
                        to={`${backUrl}/types_publipostages/`}
                        style={{
                          color: "#555B21",
                          textDecoration: "underline !important",
                        }}
                      >
                        Type doc fusion
                      </Link>
                      <i className="bx bx-caret-right"></i>
                      {!loading ? (
                        data?.sil ||
                        data?.detail_types_publipostage?.["Identification"]?.[
                          "Label"
                        ] ||
                        `#${id}`
                      ) : (
                        <span
                          className="placeholder col-3"
                          style={{ height: "1em" }}
                        ></span>
                      )}
                    </h5>
                  </div>
                  <div className="d-flex justify-content-end">
                    <div className="d-flex align-items-end gap-2">
                      {data?.can_edit ? (
                        <Link
                          to={`${backUrl}/types_publipostages/${id}/edit`}
                          className="btn btn-sm btn-primary"
                        >
                          <i className="bx bx-edit-alt"></i>Modifier
                        </Link>
                      ) : null}
                      {data?.can_destroy ? (
                        <DeleteButton
                          url={`https://www.fluxod.com/${api}/types_publipostages/${id}`}
                          redirectUrl={`${backUrl}/types_publipostages`}
                        />
                      ) : null}
                    </div>
                  </div>
                </CardBody>
                {CustomNavTabs()}
                <CardBody>
                  {activeTab === "details" && (
                    <div>
                      {!loading ? (
                        <Row>
                          <Col sm="12">
                            {data?.detail_types_publipostage?.["Identification"] ? (
                              <IdentificationCard
                                title="Identification"
                                details={data.detail_types_publipostage["Identification"]}
                              />
                            ) : (
                              <IdentificationCard
                                title="Identification"
                                details={{
                                  "Catégorie du document": data?.categories_document,
                                  "Label": data?.label,
                                  "Accès investisseur": data?.acces_investisseur,
                                  "Accès CGP": data?.acces_cgp,
                                  "Ordre": data?.ordre,
                                }}
                              />
                            )}
                          </Col>
                        </Row>
                      ) : (
                        <Spinners setLoading={setLoading} setWait={400} />
                      )}
                    </div>
                  )}
                  {activeTab === "documents_fusion" && (
                    <div className="table-responsive">
                      {documentFusionLoading ? (
                        <div className="d-flex align-items-center justify-content-center gap-2 py-4">
                          <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          />
                          <span>Chargement en cours...</span>
                        </div>
                      ) : (
                        <TableHm
                          title={documentFusionData}
                          data={documentFusionData?.data || []}
                          header={documentFusionData?.header || []}
                          itemsPerPage={10}
                          showPath="sauvegardes_attestations"
                          onShowClick={() => {
                            localStorage.setItem("typesPublipostageDetail_tab_" + id, "documents_fusion");
                          }}
                        />
                      )}
                    </div>
                  )}
                  {activeTab === "publipostages" && (
                    <div className="table-responsive">
                      {publipostagesLoading ? (
                        <div className="d-flex align-items-center justify-content-center gap-2 py-4">
                          <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          />
                          <span>Chargement en cours...</span>
                        </div>
                      ) : (
                        <TableHm
                          title={publipostagesData}
                          data={publipostagesData?.data || []}
                          header={publipostagesData?.header || []}
                          itemsPerPage={10}
                          showBaseUrl={`http://www.fluxod.com/${api}`}
                          showPath="publipostages"
                          showSuffix="/redirect_to_real_controller"
                          onShowClick={() => {
                            localStorage.setItem("previousPath_" + api, window.location.pathname);
                            localStorage.setItem("typesPublipostageDetail_tab_" + id, "publipostages");
                          }}
                        />
                      )}
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
      <ToastContainer />
    </React.Fragment>
  );
};

export default TypesPublipostageDetail;
